import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  useEffect(() => {
    // Initialize Meta Pixel manually (avoids react-facebook-pixel DOM crash)
    try {
      const pixelId = '2411207615977952';
      // Initialize fbq
      if (!(window as any).fbq) {
        const n = ((window as any).fbq = function (...args: any[]) {
          n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
        }) as any;
        if (!(window as any)._fbq) (window as any)._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        n.callMethod = null;
      }
      // Load the pixel script
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
      } else {
        document.head.appendChild(script);
      }
      // Track
      ;
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
    } catch (e) {
      // Pixel init failed silently - won't crash the app
      console.warn('Meta Pixel initialization skipped:', e);
    }
  }, []);
  return <div className="min-h-screen bg-white" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}